module.exports = __webpack_public_path__ + "img/rules-btn.9715b861.png";